import { render, staticRenderFns } from "./PublicHome.vue?vue&type=template&id=2a2a1aed&"
import script from "./PublicHome.vue?vue&type=script&lang=js&"
export * from "./PublicHome.vue?vue&type=script&lang=js&"
import style0 from "./PublicHome.vue?vue&type=style&index=0&id=2a2a1aed&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports